/* eslint-disable react/prop-types */
import React from 'react'
import PrimaryButton from '@components/inputs/button/primaryButton'
import { ModalBackground } from '@components/modal/styles'

const EventModal = ({
  showModal, event, onDelete, setShowEditModal
}) => {
  if (!event) return null

  const handleDelete = () => {
    onDelete && onDelete(event)
  }

  return (
    <ModalBackground>
      <div style={{
        background: '#fff',
        borderRadius: 12,
        padding: 24,
        width: 420,
        boxShadow: '0 2px 10px rgba(0,0,0,0.15)'
      }}
      >
        <h3 style={{ marginTop: 0, marginBottom: 8 }}>Evento</h3>
        <p style={{ marginTop: 0, marginBottom: 16 }}>{event?.title?.name || 'Sem título'}</p>

        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <PrimaryButton onClick={() => setShowEditModal(true)}>Editar</PrimaryButton>
          <PrimaryButton onClick={handleDelete}>Excluir</PrimaryButton>
          <PrimaryButton onClick={() => showModal(false)}>Fechar</PrimaryButton>
        </div>
      </div>
    </ModalBackground>
  )
}

export default EventModal
